module.exports = __webpack_public_path__ + "assets/img/th-1fe2bab9.png";